<template>
    <div class="orderList">

        <Head :headInfo='headInfo' @onClickLeft='onBack' />
        <div class="nav">
            <v-switcher :headers="tabNav" align="start" :headerHeight="44" :default-index="tabIndex" @change="handleTabSwitch">
            </v-switcher>
        </div>
        <div class="page-tab-container">
            <div v-if="orderList.length">
                <van-pull-refresh v-model="isLoading" :head-height='20' @refresh="onRefresh">
                    <van-list v-model="loading" :finished="finished" :finished-text="finishText" :immediate-check="false" @load="onLoad">
                        <div class="items" v-for="(item, index) in orderList" :key="index">
                            <div class="items_title"><i class="iconfont iconicon_dianpu"></i><span>{{ item.shopName }}</span></div>
                            <div class="head borderBot borderBotLeft0">
                                <div class="head-left f24" v-show="item.childOrderStatus == 10 || item.childOrderStatus == 50">{{ item.childOrderNo }}</div>
                                <div class="head-left f24" v-show="item.childOrderStatus == 20 || item.childOrderStatus == 60 || item.childOrderStatus == 70">{{ item.childOrderNo }}</div>
                                <div class="head-left f24" v-show="item.childOrderStatus == 30 || item.childOrderStatus == 40">{{ item.deliveryOrderNo }}</div>
                                <div class="head-right colFF7A45" :class="{'col999': item.childOrderStatus == 40 || item.childOrderStatus == 50}" v-text="isStatus(item.childOrderStatus, item.shippingMethod, item.groupParticipation)"></div>
                            </div>
                            <div class="li borderBot borderBotLeft0" v-for="(it, idx) in item.orderProductList" v-show="idx < 2" :key="it.id" @click="onDetail(item.id, item.childOrderStatus, item.orderType)">
                                <div class="li-left">
                                    <div class="img">
                                        <img v-lazy="$viewImageNew(it.productPictureUrl, 400,400)" alt="">
                                    </div>
                                </div>
                                <div class="li-right">
                                    <div class="title col000" v-text="it.skuShowName"></div>
                                    <div class="price">
                                        <div class="price" v-if="it.price !== null"><sub>¥ </sub>{{ it.price | NumFormat }} <span class="col333"><sub>X</sub>{{ it.quantity || it.shippingQuantity }}</span></div>
                                        <div class="price" v-else><sub>¥ </sub>???? <span class="col333"><sub>X</sub>{{ it.quantity || it.shippingQuantity }}</span></div>
                                    </div>
                                </div>
                            </div>
                            <div class="num" :class="{ 'borderBot borderBotLeft0': item.childOrderStatus === 10 || item.childOrderStatus === 30 || item.shippingType === 2 }">
                                共{{ item.totalQuantity || item.totalShippingQuantity }}件 合计
                                <span class="num_color" v-if="!(!item.hasSpecialFreight && !item.freight)">
                                    <!-- 待支付、待发货展示：(含运费) -->
                                    {{ item.deliveryOrderId ? ` (不含运费)` : ` (含运费)` }}
                                </span>:
                                <span class="num_price" v-if="!item.hasSpecialFreight"><sub>¥ </sub>{{ item.finalTotalAmount | NumFormat }}</span>
                                <span class="num_price" v-else>待运营维护</span>
                            </div>
                            <div class="btn" v-if="item.childOrderStatus === 10">
                                <div class="btn1" @click="onDel(item.id)">取消订单</div>
                                <div class="btn1 active" @click="onBuy(item)">立即支付</div>
                            </div>
                            <div class="btn" v-if="item.childOrderStatus === 40 && item.shippingType === 2">
                                <div class="btn1" @click="onLogistics(item.id)">查看物流</div>
                            </div>
                            <!-- <div class="btn" v-if="item.childOrderStatus === 30 && (item.shippingType === 2 || (!item.returnId && item.submitShow))"> -->
                            <div class="btn" v-if="item.childOrderStatus === 30 && (item.shippingType === 2 || item.submitShow)">
                                <div class="btn1" v-show="item.shippingType === 2" @click="onLogistics(item.id)">查看物流</div>
                                <!-- <div class="btn1 active" v-show="!item.returnId && item.submitShow" @click="onTake(item.id)">确认收货</div> -->
                                <div class="btn1 active" v-show="item.submitShow" @click="onTake(item.id)">确认收货</div>
                            </div>
                        </div>
                    </van-list>
                </van-pull-refresh>
            </div>
            <div class="msg" v-else>
                <img src="../../../assets/img/b2b/img_empty_order@2x.png" alt="">
                还没有相关的订单呢
            </div>
        </div>
        <PopupApprove ref="popApp"></PopupApprove>
        <CustomerService />
    </div>
</template>
<script>
import { getMyOrderList, getTakeOrder, orderClose } from '../api/order'
import Head from '../../common/head'
import PopupApprove from '../common/approvePopup'
import CustomerService from '../common/customerService'
import { Dialog } from 'vant'
import { mapMutations, mapActions } from 'vuex'
import { clearCache, newCache } from '@/utils/index'
export default {
    name: 'orderList',
    components: {
        Head,
        PopupApprove,
        CustomerService
    },
    data () {
        return {
            headInfo: {
                title: '采购订单'
            },
            tabNav: ['待支付', '待发货', '待收货', '待提货', '已完成', '已取消'],
            userInfo: '',
            pageNumber: 1,
            pageSize: 10,
            orderStatus: '',
            orderStatus2: 0,
            shippingMethod: '',
            tabIndex: 0,
            total: 0,
            finishText: '数据已加载完毕',
            loading: false,
            finished: false,
            isLoading: false,
            isApproveValue: 3,
            orderList: []
        }
    },
    beforeRouteEnter (to, from, next) {
        newCache('orderList')
        next()
    },
    beforeRouteLeave (to, from, next) {
        if (to.name !== 'orderDetail') {
            clearCache('orderList')
        }
        console.log(window.scrollY)
        this.$route.meta.savedPosition = window.scrollY
        next()
    },
    methods: {
        ...mapActions(['findOrderDetails', 'isApprove', 'getOrderGroupDetail']),
        ...mapMutations({
            setSCROLL: 'SCROLL_Y'
        }),
        handleTabSwitch (index) {
            localStorage.setItem('orderNum', index)
            this.orderList = []
            this.pageNumber = 1
            this.loading = false
            this.finished = false
            this.ifEalse(index)
        },
        ifEalse (index) {
            this.shippingMethod = ''
            if (index === 3) {
                this.getOrderList(30, 2)
                this.shippingMethod = 2
                this.orderStatus = 30
            } else if (index === 2) {
                this.getOrderList(30, 1)
                this.shippingMethod = 1
                this.orderStatus = 30
            } else if (index === 4) {
                this.getOrderList(40)
                this.orderStatus = 40
            } else if (index === 5) {
                this.getOrderList(50)
                this.orderStatus = 50
            } else if (index === 6) {
                this.getOrderList(60)
                this.orderStatus = 60
            } else if (index === 7) {
                this.getOrderList(70)
                this.orderStatus = 70
            } else if (index === 1) {
                this.getOrderList(20)
                this.orderStatus = 20
            } else {
                this.getOrderList(10)
                this.orderStatus = 10
            }
        },
        onLogistics (deliveryOrderId) {
            this.$router.push({ path: '/b2b/logistics/index', query: { deliveryOrderId: deliveryOrderId } })
        },
        onBack () {
            this.$router.replace({ path: '/b2b/order/index' })
        },
        async onBuy (item) {
            const { orderId, payMethod, totalAmount, childOrderId, hasSpecialFreight, freightAmount } = item
            // let groupStatus = group && group.groupStatus
            if (this.userInfo.authenticationStatus !== 3) {
                this.$refs.popApp.onShow()
                return false
            }
            if (hasSpecialFreight) {
                Dialog.alert({
                    title: '提示',
                    message: '确定有待平台确认运费商品，请先联系运营人员维护',
                    confirmButtonText: '确定',
                    confirmButtonColor: '#FF7A45'
                }).then(() => {
                })
                return
            }
            if (payMethod == 2) {
                localStorage.setItem('transferPrice', totalAmount)
                this.$router.push({ path: '/b2b/payment/transfer' })
            } else if (payMethod == 1) {
                this.$router.push({ path: '/b2b/payment/accountPay', query: { orderId: orderId, childOrders: childOrderId } })
            } else {
                localStorage.setItem('paymentBack', this.$router.history.current.fullPath)
                this.$router.push({ path: '/b2b/payment/cashier', query: { orderId: orderId, childOrders: childOrderId, freightAmount: freightAmount } })
            }
        },
        async onDetail (id, childOrderStatus, orderType) {
            this.$router.push({ path: '/b2b/order/orderDetail', query: { id: id, childOrderStatus: childOrderStatus, orderType: orderType } })
        },
        onLoad () {
            this.pageNumber += 1
            this.getOrderList()
        },
        onRefresh () {
            setTimeout(() => {
                this.finished = false
                this.orderList = []
                this.pageNumber = 1
                this.pageSize = 10
                this.getOrderList()
            }, 1000)
        },
        isStatus (num, method, group) {
            let statusName = ''
            let groupStatus = group && group.status
            switch (num) {
                case 10:
                    statusName = '待支付'
                    if (groupStatus === 10) {
                        statusName = '拼团中，' + statusName
                    }
                    return statusName
                case 20:
                    statusName = '待发货'
                    if (groupStatus === 20) {
                        statusName = '拼团中，' + statusName
                    } else if (groupStatus === 30) {
                        statusName = '拼团成功，' + statusName
                    }
                    return statusName
                case 30:
                    if (method === 2) {
                        statusName = '待提货'
                    } else {
                        statusName = '待收货'
                    }
                    if (groupStatus) {
                        statusName = '拼团成功，' + statusName
                    }
                    return statusName
                case 40:
                    statusName = '已完成'
                    if (groupStatus) {
                        statusName = '拼团成功，' + statusName
                    }
                    return statusName
                case 50:
                    statusName = '已取消'
                    return statusName
                case 60:
                    statusName = '退款中'
                    if (groupStatus === 30) {
                        statusName = '拼团成功，' + statusName
                    } else if (groupStatus === 40) {
                        statusName = '拼团失败，' + statusName
                    }
                    return statusName
                case 70:
                    statusName = '已退款'
                    if (groupStatus === 30) {
                        statusName = '拼团成功，' + statusName
                    } else if (groupStatus === 40) {
                        statusName = '拼团失败，' + statusName
                    }
                    return statusName
                default:
                    break
            }
        },
        async onDel (orderId) {
            Dialog.confirm({
                title: '',
                message: '是否取消该订单？',
                confirmButtonText: '确认',
                cancelButtonColor: '#FF7A45',
                confirmButtonColor: '#FF7A45'
            }).then(() => {
                this.closeOrder(orderId)
            }).catch(() => {
                // on cancel
            })
        },
        onTake (orderId) {
            Dialog.confirm({
                title: '',
                message: '是否确认收货？',
                confirmButtonText: '确认',
                cancelButtonColor: '#FF7A45',
                confirmButtonColor: '#FF7A45'
            }).then(() => {
                this.takeOrder(orderId)
            }).catch(() => {
                // on cancel
            })
        },
        async takeOrder (id) {
            await getTakeOrder({
                deliveryOrderId: id
            })
            this.orderList = []
            this.getOrderList()
        },
        async closeOrder (orderId) {
            await orderClose({
                cancelReason: '买家主动取消',
                orderId: orderId
            })
            this.orderList = []
            this.getOrderList()
        },
        async getOrderList (orderStatus, shippingMethod) {
            let status
            let method
            if (orderStatus) {
                status = orderStatus
            } else {
                status = this.orderStatus
            }
            if (shippingMethod) {
                method = shippingMethod
            } else {
                method = this.shippingMethod
            }
            const { data } = await getMyOrderList({
                memberCode: this.userInfo.companyCode,
                childOrderStatus: status,
                shippingMethod: method,
                pageNumber: this.pageNumber,
                pageSize: this.pageSize
            })
            data.records.forEach(item => {
                item.childOrderStatus = item.childOrderStatus || item.deliveryOrderStatus // 处理订单状态
                item.submitShow = item.orderProductList.map(it => it.returnStatus).indexOf(null) >= 0
            })
            this.orderList = this.orderList.concat(data.records)
            this.loading = false
            this.isLoading = false
            if (this.orderList.length >= data.total) {
                this.finished = true
            }
            if (data.total < this.pageSize) {
                this.finishText = ''
            }
        }
    },
    mounted () {
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
        if (!this.tabIndex && this.tabIndex !== 0) {
            this.getOrderList()
        }
    },
    created () {
        let tabNum = localStorage.getItem('orderNum') || 0
        this.tabIndex = parseInt(tabNum)
    }
}
</script>
<style lang="scss" scoped>
.orderList {
    font-size: 28px;
    background: #f5f5f5;
    .nav {
        position: fixed;
        left: 0;
        right: 0;
        background: #ffffff;
        color: #666666;
        z-index: 99;
    }
    .page-tab-container {
        margin-top: 100px;
        padding: 0 24px;
        padding-bottom: 40px;
        .items {
            background: #ffffff;
            border-radius: 12px;
            margin-top: 20px;
            &_title {
                font-size: 28px;
                padding: 32px 8px 0;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
                overflow: hidden;
                white-space: normal;
                word-break: break-all;
                span {
                    margin-left: 8px;
                    color: #000;
                }
            }
            .head {
                display: flex;
                justify-content: space-between;
                padding: 16px;
                font-size: 26px;
                color: #333333;
                position: relative;
            }
            .li {
                display: flex;
                justify-content: space-between;
                margin-left: 16px;
                padding: 24px 8px 24px 0;
                position: relative;
                // border-bottom: 2px solid rgba(209,209,214,1);
                .li-left {
                    width: 184px;
                    .img {
                        width: 184px;
                        height: 184px;
                        border-radius: 12px;
                        position: relative;
                        display: flex;
                        background: #f2f3f5;
                        img {
                            display: inline-block;
                            margin: 0 auto;
                            object-fit: cover;
                            justify-self: center;
                            align-self: center;
                        }
                    }
                }
                .li-right {
                    display: flex;
                    align-content: space-between;
                    flex-wrap: wrap;
                    flex: 1;
                    margin-left: 24px;
                    color: #333333;
                    .title {
                        flex: 0 0 100%;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        overflow: hidden;
                        white-space: normal;
                        word-break: break-all;
                    }
                    .price {
                        flex: 0 0 100%;
                        font-size: 30px;
                        color: #ff7a45;
                        sub {
                            font-size: 20px;
                        }
                        span {
                            float: right;
                        }
                    }
                }
            }
            .num {
                position: relative;
                padding: 24px 16px;
                text-align: right;
                font-size: 30px;
                color: #000000;
                &_price {
                    color: #ff7a45;
                    sub {
                        font-size: 20px;
                    }
                }
                &_color {
                    font-size: 26px;
                    color: #999;
                }
            }
            .btn {
                display: flex;
                justify-content: flex-end;
                padding: 24px 16px;
                .btn1 {
                    width: 208px;
                    text-align: center;
                    height: 64px;
                    line-height: 64px;
                    font-size: 28px;
                    color: #ff7a45;
                    border: 2px solid #ff7a45;
                    border-radius: 64px;
                    margin-left: 24px;
                    &.active {
                        color: #ffffff;
                        background: #ff7a45;
                        border: 2px solid #ff7a45;
                    }
                    &.active2 {
                        color: #ffffff;
                        background: #cccccc;
                        border: 2px solid #cccccc;
                    }
                }
            }
        }
    }
    .loading {
        color: #999;
        text-align: center;
        padding: 40px;
    }
    .msg {
        width: 250px;
        font-size: 26px;
        color: #c7c7cc;
        margin: 0 auto;
        padding-top: 160px;
        text-align: center;
        img {
            width: 176px;
            height: 176px;
            margin: 0 auto;
            display: block;
        }
    }
}
/deep/ .v-switcher-header-item {
    padding: 0 32px;
    font-size: 28px;
    &.is-active {
        color: #ff7a45;
    }
}
/deep/ .van-pull-refresh {
    overflow: initial;
}
/deep/ .mint-loadmore {
    overflow: inherit;
}
/deep/ .iconfont {
    font-size: 32px;
    vertical-align: bottom;
    color: #999;
}
</style>
